import { apiMethodTypes } from 'constants/apiMethodTypes'

export const makeApiCall = async <T>(request: Request): Promise<T> => {
  const response = await fetch(request)
  if (response.ok === false) {
    throw Error()
  }
  return response.json() as Promise<T>
}

export const getRequest = (url: string): Request => {
  const myHeaders = new Headers()

  const isAutomation = window.sessionStorage.getItem('automation')
  if (isAutomation) {
      myHeaders.append('IsAutomation', isAutomation)
  }

  return new Request(url, {
    credentials: 'include',
    headers: myHeaders,
    method: apiMethodTypes.get,
    mode: 'cors',
  })
}

export const postRequest = <T>(url: string, body: T): Request => {
  const myHeaders = new Headers()
  return new Request(url, {
    body: JSON.stringify(body),
    credentials: 'include',
    headers: {
      ...myHeaders,
      'Content-Type': 'application/json',
    },
    method: apiMethodTypes.post,
    mode: 'cors'
  })
}

export default {
  getRequest,
  makeApiCall,
  postRequest
}



// WEBPACK FOOTER //
// ./src/network/api-client.ts